<template>
    <div class="home" align="center">
        <v-card class="my-5 mb-5" height="100%" max-height="200"> 
            <v-img 
                src="https://images.unsplash.com/photo-1512641406448-6574e777bec6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c3Vuc2V0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                class="white--text align-center"
                max-height="200"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            >
                <v-card-text class="text-center py-3">
                <v-row>
                    <v-col cols="4">
                        <v-img src="@/assets/sun.jpg" max-height="100" max-width="100" class="mx-auto"></v-img>
                        <p class="my-auto font-weight-black" style="font-size: 32px">{{sunrise_suntime_hours}}:{{sunrise_suntime_minutes}}</p>
                        <p class="mt-3">Civil</p>
                        <p class="mt-n4">Sunrise</p>
                    </v-col>
                    <v-col cols="4" class="my-6 font-weight-medium text-center">
                        <v-row><p class="mx-auto my-1">{{location}}</p></v-row>
                        <v-row><p class="mx-auto my-1">{{today}}</p></v-row>
                        <v-row>
                            <v-img
                                :src="sky_img"
                                max-height="75"
                                max-width="75"
                                class="mt-n5 mx-auto"
                            ></v-img>
                        </v-row>
                        <v-row>
                            <p class="my-n3 mx-auto">{{sky_status}}, {{sky_temp}}°F</p>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-img src="@/assets/moon.jpg" max-height="100" max-width="100" class="mx-auto"></v-img>
                        <p class="my-auto font-weight-black" style="font-size: 32px">{{sunset_suntime_hours}}:{{sunset_suntime_minutes}}</p>
                        <p class="mt-3">Civil</p>
                        <p class="mt-n4">Sunset</p>
                    </v-col>
                </v-row>
                </v-card-text>
            </v-img>
        </v-card>
        <v-card class="my-5" height="100%" max-height="650">
            <v-list-item dense>
                <v-list-item-content>
                    <p class="text-h6 mt-2 font-weight-bold text-center grey--text text--darken-1">Current Status</p>
                </v-list-item-content>
            </v-list-item>
            <v-card-text v-if="!ready || metersOFF === 0" class="text-center">
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        color="accent"
                        indeterminate
                    ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else class="d-flex py-2">
                <v-col>
                    <v-row class="mt-n3">
                        <v-col cols="12" md="4" class="my-auto">
                            <p class="my-auto mx-auto font-weight-black text-h4 green--text">{{metersON}}</p>
                            <v-btn text color="green" @click="showTable('on')">ON DEVICES</v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="my-auto">
                            <p class="my-auto font-weight-black text-h4">{{metersOFF}}</p>
                            <v-btn text @click="showTable('off')">OFF DEVICES</v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="my-auto">
                            <p class="my-auto font-weight-black text-h4 red--text">{{metersOUT}}</p>
                            <v-btn text color="red" @click="showTable('out')">OFFLINE DEVICES</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                    </v-row>
                    <div style="font-size: 12px">
                        <p class="mb-n2 mt-auto text-right">Last Update: {{todayFormatted}} at {{actualHour}} hrs</p>
                    </div>
                </v-col>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name: 'Main',
    computed: {
        ...mapState({
            location: state => state.user.location,
            sunrise_suntime_hours : state => state.user.sunrise_suntime_hours,
            sunrise_suntime_minutes: state => state.user.sunrise_suntime_minutes,
            sunset_suntime_hours: state => state.user.sunset_suntime_hours,
            sunset_suntime_minutes: state => state.user.sunset_suntime_minutes,
            sky_status: state => state.user.sky_status,
            sky_img: state => state.user.sky_img,
            sky_temp: state => state.user.sky_temp,
            meters: state => state.meters.meters,
            metersON: state => state.meters.metersON,
            metersUP: state => state.meters.metersUP,
            metersDOWN: state => state.meters.metersDOWN,
            metersOFF: state => state.meters.metersOFF,
            metersOUT: state => state.meters.metersOUT,
            metersAPI: state => state.meters.metersAPI,
            records: (state) => state.meters.lastReadings,
            sky_ofs: state => state.user.sky_ofs,
        }),
    },
    data() {
        return {
            menu: false,
            today: '',
            todayFormatted: '',
            actualHour: '',
            temp: 0,
            status: '',
            dn: '',
            link: null,
            sr_hour: '',
            ss_hour: '',
            arrayNames: [],
            ready: false,
            mON: null,
            mOFF: null,
            mOUT: null,
        } 
    },
    methods: {
        async dateToday(timeStamp) {
            let year = new Date(timeStamp).getFullYear();
            let month = new Date(timeStamp).getMonth();
            let arrayMonths = ['January','February','March','April','May','June','July','August','September','October','November','December'];
            let weekDay = new Date(timeStamp).getDay();
            let arrayDays = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
            let date = new Date(timeStamp).getDate();
            this.today = arrayDays[weekDay] + ", " + arrayMonths[month] + ' ' + date + ", " + year;
            this.todayFormatted = (month+1) + "/" + date + "/" + year
            const utc = moment()
            const hour = utc.format("LTS")
            this.actualHour = moment(hour, "h:mm:ss A").format('HH:mm')
            await this.sleep(2000).then(() => { this.ready = true; });
        },
        nowTimes(){
            this.dateToday(new Date());
        },
        showTable(status){
            this.$router.push({ name: 'StatusCircuit' , params: { id: status }})
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
    },
    async created(){
        await this.sleep(1000).then(() => { this.ready = false; });
        this.nowTimes()
    },
}
</script>
